var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "form-group filterfield",
      attrs: {
        id: _vm.htmlId,
        "data-filterfield-type": _vm.definition.componentName,
      },
    },
    [
      _vm.showLabel
        ? _c(
            "label",
            { staticClass: "col-xs-12", attrs: { for: _vm.inputId } },
            [
              _vm._v(_vm._s(_vm.displayName) + " "),
              _c("Debug", [_vm._v("(id: " + _vm._s(_vm.id) + ")")]),
            ],
            1
          )
        : _c("Debug", [
            _c("label", { staticClass: "col-xs-12" }, [
              _vm._v("(id: " + _vm._s(_vm.id) + ")"),
            ]),
          ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c("Autocomplete", {
            staticClass: "form-control",
            attrs: {
              type: "text",
              useQuoteAsWordBoundary: "",
              id: _vm.inputId,
              placeholder: _vm.displayName,
              dir: _vm.textDirection,
              url: _vm.autocompleteUrl,
            },
            model: {
              value: _vm.modelvalue,
              callback: function ($$v) {
                _vm.modelvalue = $$v
              },
              expression: "modelvalue",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _vm.description
        ? _c("div", { staticClass: "col-xs-12" }, [
            _c("small", { staticClass: "text-muted description" }, [
              _c("em", [_vm._v(_vm._s(_vm.description))]),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }